export default __webpack_public_path__ + "static/media/avatar.1918a335.jpg";